<template>
  <v-form>
    <!-- <v-text-field v-model="userGuess" label="Guess the movie"></v-text-field> -->
    <v-row class="my-1" :class="{'mx-0': get_xs}">
      <v-autocomplete
        label="Guess the movie"
        :items="movie_list"
        item-title="movie_name"
        item-value="movie_name"
        return-object
        density="compact"
        v-model="userGuess"
        variant="outlined"
        clearable
        single-line
        :menu-props='{maxHeight: 0}'
        :block="smAndDown"
        hide-selected
        placeholder="Start Guessing"
        hide-no-data
        @input="check_inp"
        ref="guess_val"
        autofocus
        auto-select-first
      ></v-autocomplete>

      <v-btn :class="smAndDown ? 'ml-0' : 'ml-2'" class="bg-black mx-0 px-2"  size="large" @click="checkGuess" :block="smAndDown">
        🍿 Guess
      </v-btn>
    </v-row>
    <v-btn v-if="correct == 1" block @click="correct=0;reset();" :class="{'text-caption': get_xs}" class="bg-green-accent-2 my-2">{{streak_messages}}, keep going</v-btn> 
    <v-btn v-if="correct == 2" block @click="correct=0;reset();" :class="{'text-caption': get_xs}
" class="bg-red-darken-3 my-2">{{streak_messages_incorrect}}, load new clip</v-btn>
    <v-row v-if="correct == 1">
      <v-col>
        <v-card
            class="bg-grey-darken-4 text-white"
          >
            <v-row class="py-2">
              <v-col cols="3" class="mr-1">
                <v-avatar
                  class="ma-2"
                  :size="get_xs_size"
                  rounded="0"
                >
                  <v-img :src="`https://image.tmdb.org/t/p/${get_xs_size_for_poster}/${movieClip.poster}`"></v-img>
                </v-avatar>
              </v-col>
              <v-col cols="8">
                <div :class="{'text-overline': get_xs}" class="text-h6 px-1">
                  {{movieClip.movie_name}}
                  <span class="text-overline">({{movieClip.year_released}})</span>
                </div>

                <p :class="{'text-caption': get_xs}" class="px-1 text-subtitle-2" >{{movieClip.desc}}</p>
                <div class="my-2">
                  <v-chip

                    class="ma-1"
                    color="secondary"
                    v-for="(genre, idx) in movieClip.genre"
                    :key="idx"
                    >
                      {{genre}}
                  </v-chip>

                  <a :href="`https://www.imdb.com/title/${movieClip.imdb_id}/`" target="_blank">
                    <v-chip

                        variant="elevated"
                        color="yellow"
                        class="text-black font-weight-black ma-1"
                        style="cursor: pointer"
                      > 
                        IMDb
                    </v-chip>
                  </a>
                </div>
              </v-col>

              
            </v-row>
          </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>

import { getMovieList } from "@/services/supabaseService";


export default {

  computed:{
    smAndDown() {
      return this.$vuetify.display.smAndDown;
    },

    xs() {
      if(this.$vuetify.display.xs){
        return 12;
      }else{
        return 3;
      }
    },

    get_xs_size() {
      if(this.$vuetify.display.xs){
        return 92;
      }else{
        return 154;
      }
    },

    get_xs_size_for_poster() {
      if(this.$vuetify.display.xs){
        return 'w92';
      }else{
        return 'w154';
      }
    },

    get_xs() {
      return this.$vuetify.display.xs;
    },

    smAndUp() {
      return this.$vuetify.display.smAndUp;
    },

    streak_messages(){
      return this.streak_msgs[Math.floor(Math.random()*this.streak_msgs.length)];
    },

    streak_messages_incorrect(){
      return this.streak_msgs_incrrect[Math.floor(Math.random()*this.streak_msgs_incrrect.length)];
    },
    
  },
  
  props: {
    movieClip: Object,
    getClip: Function,
    increment_streak: Function,
    reset_streak: Function,
  },
  mounted(){
    this.get_movie_list();
  },
  data() {
    return {
      userGuess: "",
      counter_val: null,
      userScore: 0,
      guessFeedback: "",
      movie_list: [],
      correct: 0,
      streak_msgs: ["Sir you are genius", "Lucky guess?", "Streak is good", "Nice guess", "You're on a roll", "Spot-on star!", "You're on fire!", "Genius at work!", "Impressive!", "Nailed it, champ!", "Unstoppable!"],
      streak_msgs_incrrect: ["Oops you lost the streak", "Missed it", "Wrong you moron!", "Close, but no popcorn", "Failed miserably", "You have dissapointed", "Nope you dummy", "Stupid guess", "Not even close", "You father is dissapointed in you"]
    };
  },
  methods: {


    reset(){
      this.getClip();
    },

    checkGuess() {
      if (this.userGuess.movie_name === this.movieClip.movie_name) {
        
        this.correct = 1;
        this.increment_streak();
        this.$confetti.start(
            {
              particles: [
                {
                  type: 'rect',
                },
                
              ],
              defaultSize: 5
            }
        );
        setTimeout(function () {
            this.$confetti.stop();
        }.bind(this), 2000)
      } else {
        this.correct = 2;
        this.reset_streak();
      }
    },

    check_inp(){
      // console.log(this.refs["guess_val"]);
      if(this.$refs["guess_val"].search.length > 3){
        this.$refs["guess_val"].menuProps.maxHeight = 65;
      }else{
        this.$refs["guess_val"].menuProps.maxHeight = 0;
      }
    },


    async get_movie_list(){
      this.movie_list = await getMovieList();
    }
  },
};
</script>